import React, { useState, useEffect, useRef } from 'react';
import { Form, Tag, message, DatePicker, Select } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './studentSeeAllJobApplicationsSort.css';
import PropTypes from 'prop-types';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import approveImg from '../../public/img/newMain/Approve.png';
import resetWhite from '../../public/img/newMain/resetWhite.png'
import context from '../../public/js/context';
/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
const {Option} = Select
let StudentSeeAllJobApplicationsSort = ({ onOpenChange, isReset }) => {
    const [form] = Form.useForm();

    const [selectedConditions, setSelectedConditions] = useState({});
    const [jobTypeList, setJobTypeList] = useState([]);
    const [positionTypeList, setPositionTypeList] = useState([]);
    const [workLocList, setWorkLocList] = useState([]);
    const [areaOptions, setAreaOptions] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});
    const [allCompany, setAllCompany] = useState([]);
    const [sortOptions, setSortOptions] = useState([]);
    const jobPostModelRef = useRef({});
    /**
     * 标题默认值处理
     */
    useEffect(() => {
        searchJobType();
        searchPositionType();
        searchWorkLoc();
        searchAllArea();
        searchAllCompany();
        setSortOptions([
            {
                label: "",
                value: ""
            },
            {
                label: "Job Application ID",
                value: "job_appl_id"
            },
            {
                label: "Job ID",
                value: "job_id"
            },
            {
                label: "Job Title",
                value: "job_title"
            },
            {
                label: "Application Date",
                value: "apply_date"
            },
            {
                label: "Status",
                value: "job_appl_status"
            },
        ])
    }, []);

    useEffect(() => {
        if (isReset) {
            reset()
        }
    }, [isReset])

    const handleChange = (selectedOption) => {
        form.setFieldValue('orderBy',selectedOption)
    };

    const save = () => {
        form.validateFields().then(() => {
            selectedConditions['jobType'] ? jobPostModel.jobTypeList = selectedConditions['jobType'] : "";
            selectedConditions['positionType'] ? jobPostModel.positionTypeList = selectedConditions['positionType'] : "";
            // selectedConditions['partnerId'] ? jobPostModel.partnerIdList = selectedConditions['partnerId'] : "";
            let companyNameList = form.getFieldValue('partnerId');
            let partnerIdList = allCompany.filter(item => companyNameList?.some(i => i == item.companyName))?.map(item => item.partnerId);
            jobPostModel.partnerIdList = partnerIdList;
            jobPostModel.studentAppliedInputStart = form.getFieldValue('studentAppliedInputStart');
            jobPostModel.studentAppliedInputEnd = form.getFieldValue('studentAppliedInputEnd');
            jobPostModel.commenceStartDate = form.getFieldValue('startDate');
            jobPostModel.commenceEndDate = form.getFieldValue('endDate');
            jobPostModel.expEndDateStart = form.getFieldValue('expectedStartDate');
            jobPostModel.expEndDate = form.getFieldValue('expectedEndDate');
            jobPostModel.orderBy = form.getFieldValue('orderBy');
            jobPostModel.jobApplStatus = form.getFieldValue('jobApplStatus');
            onOpenChange(false, true, jobPostModel)
        })
    }

    const reset = () => {
        setSelectedConditions({});
        form.resetFields()
        setJobPostModel({})
    }

    const close = () => {
        onOpenChange(false, false)
    }

    const onChangeAddressA = (value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ workLocIdList: value } };
            return { ...model, ...{ workLocIdList: value } };
        });
    }

    const searchAllCompany = () => {
        Base.callBackApi("commonDropDown/searchAllCompany").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setAllCompany(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchJobType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "JOB_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setJobTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchPositionType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "POSITION_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setPositionTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchWorkLoc = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "WORK_LOCATION" }).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setWorkLocList(list ?? []);
            } else {
                message.error(data?.msg);
            }
        }).catch(err => { });
    }

    const handleConditionClick = (condition, groupName) => {
        const updatedSelectedConditions = { ...selectedConditions };
        if (!updatedSelectedConditions[groupName]) {
            updatedSelectedConditions[groupName] = [];
        }

        const index = updatedSelectedConditions[groupName].indexOf(condition);
        if (index !== -1) {
            // 如果已选中，则移除
            updatedSelectedConditions[groupName].splice(index, 1);
        } else {
            // 如果未选中，则添加
            updatedSelectedConditions[groupName].push(condition);
        }

        setSelectedConditions(updatedSelectedConditions);
    };

    const isConditionSelected = (condition, groupName) => {
        if (selectedConditions[groupName]) {
            return selectedConditions[groupName].includes(condition);
        }
        return false;
    };

    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('endDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('startDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const checkStartDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('expectedEndDate')) && Base.afterDate(form.getFieldValue('expectedStartDate'), form.getFieldValue('expectedEndDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('expectedStartDate')) && Base.afterDate(form.getFieldValue('expectedStartDate'), form.getFieldValue('expectedEndDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const studentAppliedInputStart = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('studentAppliedInputEnd')) && parseInt(form.getFieldValue('studentAppliedInputStart')) > parseInt(form.getFieldValue('studentAppliedInputEnd'))) {
            return Promise.reject("Start number cannot be later than end number.");
        }
        return Promise.resolve();
    }

    const studentAppliedInputEnd = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('studentAppliedInputStart')) && parseInt(form.getFieldValue('studentAppliedInputStart')) > parseInt(form.getFieldValue('studentAppliedInputEnd'))) {
            return Promise.reject("End number cannot be smaller than start number.")
        }
        return Promise.resolve();

    }


    return (
        <div className='studentSeeAllJobApplicationsSort'>
            <Form form={form}>
                <div>
                    <div className='closePopover' onClick={close}><CloseCircleOutlined /></div>
                    <div className='Title'>
                        <span className='lable'>Job Mode :</span>
                        {
                            positionTypeList?.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.paramId, 'positionType') ? 'selected' : 'noSelected'}
                                    onClick={() => handleConditionClick(item.paramId, 'positionType')}>{item.parmValue1}</Tag>
                            )
                        }
                    </div>
                    <div className='Title'>
                        <span className='lable'>Employment Type :</span>
                        {
                            jobTypeList?.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.paramId, 'jobType') ? 'selected' : 'noSelected'}
                                    onClick={() => handleConditionClick(item.paramId, 'jobType')}>{item.parmValue1}</Tag>
                            )
                        }
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>IP Company :</span>
                        {/* <div className='lableValue'>
                            {
                                allCompany?.map((item, index) =>
                                    <Tag key={index} className={isConditionSelected(item.partnerId, 'partnerId') ? 'selected' : 'noSelected'}
                                        onClick={() => handleConditionClick(item.partnerId, 'partnerId')}>{item.companyName}</Tag>
                                )
                            }
                        </div> */}
                        <Form.Item
                            name="partnerId"
                        >
                            <Select mode="multiple" allowClear className='partnerSelector'>
                                {
                                    allCompany?.map(item => <Option key={item.partnerId} value={item.companyName}>{item.companyName}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </div>

                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Expected Commence Date :</span>
                        <span style={{ display: 'flex' }}>
                            <div>
                                <Form.Item
                                    name="startDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkStartDate(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <div>
                                <Form.Item
                                    name="endDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkEndDate(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                        </span>
                    </div>

                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Expected End Date :</span>
                        <span style={{ display: 'flex' }}>
                            <div>
                                <Form.Item
                                    name="expectedStartDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkStartDate2(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <div>
                                <Form.Item
                                    name="expectedEndDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkEndDate2(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                        </span>
                    </div>
                    {/* <div className='Title' style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'flex' }}>
                            <span className='lable'>Student Applied :</span>
                            <Form.Item
                                name="studentAppliedInputStart"
                                rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                    { validator: (rule, value) => studentAppliedInputStart(value) },
                                ]}
                            >
                                <Input className='studentAppliedInput' type="number"
                                    onInput={(e) => {
                                        let inputValue = e.target.value;
                                        inputValue = inputValue.replace(/[^\d]/g, '');
                                        if (parseInt(inputValue) < 0) {
                                            e.target.value = '';
                                        } else {
                                            e.target.value = inputValue;
                                        }
                                    }}
                                />
                            </Form.Item>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <Form.Item
                                name="studentAppliedInputEnd"
                                rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                    { validator: (rule, value) => studentAppliedInputEnd(value) },
                                ]}
                            >
                                <Input className='studentAppliedInput' type="number"
                                    onInput={(e) => {
                                        let inputValue = e.target.value;
                                        inputValue = inputValue.replace(/[^\d]/g, '');
                                        if (parseInt(inputValue) < 0) {
                                            e.target.value = '';
                                        } else {
                                            e.target.value = inputValue;
                                        }
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div> */}
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Sort By :</span>
                        <Form.Item
                            name="orderBy"
                        >
                            <Select
                                onChange={handleChange}
                                options={sortOptions}
                            />
                        </Form.Item>
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Status :</span>
                        <Form.Item
                            name="jobApplStatus"
                        >
                            <Select >
                                <Option value=""></Option>
                                {context.jobApplStatusMap.map(item => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
            </Form>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={approveImg} />Confirm</div>
                <div className='resetButton' onClick={reset}><img src={resetWhite} />Reset</div>
            </div>

        </div>
    )

}
StudentSeeAllJobApplicationsSort.propTypes = {
    onOpenChange: PropTypes.func.isRequired,
    isReset: PropTypes.bool.isRequired,
};
export default StudentSeeAllJobApplicationsSort;